import { ReactNode } from "react";

export type LinkButtonTemplateProps = {
  label: string | ReactNode;
  onClick: () => void;
  className?: string;
};

export const LinkButtonTemplate = ({
  onClick,
  label,
  className = "text-sm font-normal text-brand-orange hover:text-primary-dark transition-colors inline-flex items-center justify-center",
}: LinkButtonTemplateProps): JSX.Element => {
  return (
    <button
      onClick={onClick}
      type="button"
      className={`bg-transparent border-none p-0 ${className}`}
    >
      {label}
    </button>
  );
};
